import { render, staticRenderFns } from "./EntitlementsView.vue?vue&type=template&id=16a1812b&scoped=true"
import script from "./EntitlementsView.vue?vue&type=script&lang=js"
export * from "./EntitlementsView.vue?vue&type=script&lang=js"
import style0 from "./EntitlementsView.vue?vue&type=style&index=0&id=16a1812b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a1812b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/8268df4d62037a26/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16a1812b')) {
      api.createRecord('16a1812b', component.options)
    } else {
      api.reload('16a1812b', component.options)
    }
    module.hot.accept("./EntitlementsView.vue?vue&type=template&id=16a1812b&scoped=true", function () {
      api.rerender('16a1812b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/modules/admin/components/Entitlements/EntitlementsView.vue"
export default component.exports